import _ from 'underscore';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as filters from '@bingads-webui-campaign-legacy/location-targets/util/filters';
import campaignType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';

export default class Connector {
  constructor(languageObservable, bid, adDistribution, keyword, useCampaignSettings) {
    this.bid = bid;
    this.adDistribution = adDistribution;
    this.keyword = keyword;
    this.language = languageObservable();
    this.languages = [];
    this.isSignupPage = false;

    this.adGroupCriterions = jsdata.Intermediate.getAll('AdGroupCriterion');
    this.campaignCriterions = jsdata.Intermediate.getAll('CampaignCriterion');

    this.useCampaignSettings = useCampaignSettings;

    languageObservable.subscribe((newLanguage) => {
      this.language = newLanguage;
      this.languages = [newLanguage];
      this.onChange();
    });

    jsdata.Intermediate.subscribe('AdGroupCriterion', (adGroupCriterions) => {
      this.adGroupCriterions = adGroupCriterions;
      this.onChange();
    });

    jsdata.Intermediate.subscribe('CampaignCriterion', (campaignCriterions) => {
      this.campaignCriterions = campaignCriterions;
      this.onChange();
    });

    if (this.adDistribution) {
      this.adDistribution.on('search:change', (checked) => {
        if (_.isFunction(this.bid.resetSearchBidStatus)) {
          this.bid.resetSearchBidStatus(checked);
        }
      });
    }

    this.startListening();
  }

  startListening() {
    eventDispatcher.on('level:changed', (level) => {
      this.useCampaignSettings = level === 'campaign';
      this.onChange();
    }, this);

    //event is triggered when location targeting option is changed (specific, everywhere, bundle)
    eventDispatcher.on('change:locationTargetOption', ({locations, level}) => {
      if (level === 'campaign') {
        this.campaignCriterions = locations;
      } else {
        this.adGroupCriterions = locations;
      }

      this.onChange();
    }, this);
  }

  stopListening() {
    eventDispatcher.off(null, null, this);
  }

  setLanguageSet(languages) {
    this.languages = languages;
  }

  onChange() {
    //check if kp and traffic estimation is enabled or not
    this.isKPAndTrafficEstimationAllowed();

    //check if synd is enabled or not based on language and included location targetings
    this.isSyndicationAllowed();
  }

  isSyndicationAllowed() {
    const locations = this.currentLevelLocations;

    if (this.adDistribution) {
      this.adDistribution.isSyndOptionAllowed(this.language, locations);
    }
  }

  get currentLevelLocations() {
    return this.useCampaignSettings ? this.campaignCriterions : this.adGroupCriterions;
  }

  isKPAndTrafficEstimationAllowed() {
    const locations = this.currentLevelLocations;

    this.allowAdInsight =
      campaignType() === 'search' || this.isSignupPage;

    if (this.bid) {
      this.bid.searchBidView.onLanguageLocationChanged(this.allowAdInsight, locations, this.language === null ? this.languages : [this.language]);
    }

    if (this.keyword) {
      this.keyword.onLanguageLocationChanged(this.allowAdInsight, locations, this.language === null ? this.languages : this.language);
    }
  }

  setSignupPage() {
    this.isSignupPage = true;
  }
}
